"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityFiltersQuery = void 0;
var client_1 = require("@apollo/client");
var lodash_1 = require("lodash");
var entityFiltersQuery = function (context) {
  var definition = context.definition,
    entities = context.entities;
  var filters = definition.filters;
  var _a = filters.fields,
    fields = _a === void 0 ? {} : _a;
  var linkedFields = (0, lodash_1.pickBy)(fields, function (field) {
    return !!field.entityTypeName;
  });
  var subFields = (0, lodash_1.filter)((0, lodash_1.map)(linkedFields, function (spec, fieldName) {
    var definition = entities[spec.entityTypeName];
    if (definition) {
      var select = definition.select;
      return "\n        ".concat(fieldName, ":list").concat(definition.pluralTypeName).concat(select.filterArgs ? "(".concat(select.filterArgs, ")") : "", " {\n          results {\n            id\n            name\n            slug\n            _optionLabel\n            ").concat(select.queryFields ? select.queryFields : '', "\n          }\n        }\n      ");
    }
  }));
  return (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query ", "FiltersQuery {\n      ", "\n    }\n  "], ["\n    query ", "FiltersQuery {\n      ", "\n    }\n  "])), definition.typeName, subFields.join(' '));
};
exports.entityFiltersQuery = entityFiltersQuery;
var templateObject_1;